import { useState } from "react";
import PropTypes from "prop-types";
import { Alert, Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import OnetimePassword from "components/Auth/OnetimePassword";
import Lang from "components/Lang";

const MfaCodeSender = ({ submit, error }) => {
  const [code, setCode] = useState("");
  const [codeValid, setCodeValid] = useState(false);
  const checkSubmittable = () => codeValid;
  const codeObserver = (result) => {
    setCode(result.code);
    setCodeValid(result.valid);
  };
  const submitHandler = (event) => {
    event.preventDefault();
    if (!checkSubmittable()) {
      return;
    }
    submit(code);
  };
  return (
    <Container fluid={true}>
      <Row className="mt-5">
        <Col xs={"12"} sm={{ span: "8", offset: "2" }} md={{ span: "6", offset: "3" }} lg={{ span: "4", offset: "4" }} >
          <h3><Lang>2要素認証の要求</Lang></h3>
          <Card>
            <Card.Body>
              {error && (
                <Alert variant="warning">
                  <p className="mb-0"><Lang>ワンタイムパスワードの認証に失敗しました。</Lang></p>
                </Alert>
              )}
              <Form onSubmit={submitHandler}>
                <OnetimePassword label="ワンタイムパスワード" observer={codeObserver} />
                <Form.Group className="clearfix mt-3">
                  <Button variant="primary" className="float-end" type="submit" disabled={!checkSubmittable()}>
                    <Lang>送信</Lang>
                  </Button>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
MfaCodeSender.propTypes = {
  submit: PropTypes.func.isRequired
};

export default MfaCodeSender;